module.exports = "<div class=\"sphere\" [style.height]=\"size\" [style.width]=\"size\" [style.float]=\"position\">\n  <span class=\"sphere__title\" [style.font-size]=\"fontSize\" [innerHTML]=\"text\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/philips-marks/orange-sphere/orange-sphere.component.html
// module id = ../../../../../src/app/components/philips-marks/orange-sphere/orange-sphere.component.html
// module chunks = main